import styled from 'styled-components';

import { space4XL } from '@xing-com/tokens';

export const RecommendationPageContainer = styled.div`
  margin: 0 0 ${space4XL};
`;
